import React from 'react';
import './PageLoader.css';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <div className="loader-container">
        {/* Animated Logo */}
        <div className="loader-logo">
          <img src="/assets/logo2.png" alt="Francis Odame Writes" className="logo-image" />
        </div>
        
        {/* Loading Animation */}
        <div className="loader-content">
          <div className="loader-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
          
          <div className="loader-text">
            <h3>Loading Amazing Content</h3>
            <p>Preparing your experience...</p>
          </div>
        </div>
        
        {/* Progress Bar */}
        <div className="loader-progress">
          <div className="progress-bar">
            <div className="progress-fill"></div>
          </div>
        </div>
      </div>
      
      {/* Background Animation */}
      <div className="loader-background">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
        <div className="floating-shape shape-4"></div>
      </div>
    </div>
  );
};

export default PageLoader;
